import { render, staticRenderFns } from "./goodsDetail.vue?vue&type=template&id=5f2a76f0&"
import script from "./goodsDetail.vue?vue&type=script&lang=js&"
export * from "./goodsDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/admin_admin-web_uLO7/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5f2a76f0')) {
      api.createRecord('5f2a76f0', component.options)
    } else {
      api.reload('5f2a76f0', component.options)
    }
    module.hot.accept("./goodsDetail.vue?vue&type=template&id=5f2a76f0&", function () {
      api.rerender('5f2a76f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/bianlidianManage/goods/goodsDetail.vue"
export default component.exports